import { render, staticRenderFns } from "./alliancesByCategory.vue?vue&type=template&id=91238f3c&scoped=true&"
import script from "./alliancesByCategory.vue?vue&type=script&lang=js&"
export * from "./alliancesByCategory.vue?vue&type=script&lang=js&"
import style0 from "./alliancesByCategory.vue?vue&type=style&index=0&id=91238f3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91238f3c",
  null
  
)

export default component.exports